import CloseIcon from '@mui/icons-material/Close';
import { Card, CardHeader } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import { DesignToken } from '~c/components/base/core';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

export interface ContainerProps extends React.PropsWithChildren {
  className?: string;
  title?: string;
  onModalClose?: (evt: React.MouseEvent) => void;
  hideCloseButton?: boolean;
}

const ContainerImpl: React.FC<ContainerProps> = ({
  className,
  title,
  onModalClose,
  hideCloseButton = false,
  children,
}) => {
  return (
    <Card className={className} raised>
      <CardHeader
        sx={{ p: 0, pb: spc.m }}
        title={
          <Arranger alignItems="center" justify="center">
            <div className="left-action" />
            <Text className="title" sz="h1" align="center">
              {title}
            </Text>
            {!hideCloseButton && (
              <IconButton
                className="right-action"
                onClick={onModalClose}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            )}
            {hideCloseButton && <div className="right-action" />}
          </Arranger>
        }
      />
      {children}
    </Card>
  );
};

const Container = muiStyled(ContainerImpl)(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;

    &.MuiCard-root {
      padding: ${theme.spacing(spc.m)};

      /* If following Figma design, we have a black on black modal */
      /* border: 1px solid ${DesignToken.borderDefault}; */
      /* background-image: inherit; */
    }

    .title {
      flex-grow: 1;
    }

    .left-action,
    .right-action {
      /* reserve same space on either side of title, so title is always centered */
      flex-basis: 40px;
      color: ${DesignToken.textMuted};
    }

    .right-action {
      text-align: right;
    }
  `
);
export default Container;
